<section class="table-content-card">
    <div class="flex justify-content-between mb-4">
        <h3 class="m-0">كشف حساب العميل {{ customer?.name }} - {{ customer?.code }}</h3>
        <div class="header-actions flex justify-content-between">
            <span class="p-float-label w-14rem mx-2">
                <p-date-picker
                    class="w-full"
                    styleClass="w-full"
                    [(ngModel)]="dates"
                    (ngModelChange)="onDateChange()"
                    [dateFormat]="'yy-mm-dd'"
                    [iconDisplay]="'input'"
                    selectionMode="range"
                    [showButtonBar]="true"
                    [showIcon]="true"
                    inputId="calendar" />
                <label [htmlFor]="'calendar'" class="text-sm">التقويم</label>
            </span>
            <p-button icon="pi pi-print" (onClick)="printCustomerStatement()" label="طباعة كشف الحساب"></p-button>
        </div>
    </div>
    <!-- supplier statemnet TABLE -->
    <div class="customers-table">
        <p-table
            [value]="statementRows"
            (rowsChange)="limit = $event"
            [loading]="loading"
            [scrollable]="true"
            scrollHeight="65vh"
            [tableStyle]="{ 'max-height': '50vh', 'min-height': tableMinHeight, 'overflow-y': 'auto' }">
            <ng-template pTemplate="header">
                <tr>
                    <th>التاريخ</th>
                    <th>المرجع</th>
                    <th>مدين</th>
                    <th>دائن</th>
                    <th>المبلغ المستحق</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{ item.createdAt | date: 'YYYY-MM-dd' }}</td>
                    <td>
                        <span class="underline cursor-pointer" *ngIf="item.isRoutable" (click)="routeToSource(item)">{{
                            item.description
                        }}</span>
                        <span *ngIf="!item.isRoutable">{{ item.description }}</span>
                    </td>
                    <td>{{ (item.changeAmount > 0 ? item.changeAmount : 0) | number: '1.2-2' }}</td>
                    <td>{{ (item.changeAmount < 0 ? Math.abs(item.changeAmount) : 0) | number: '1.2-2' }}</td>
                    <td>{{ -item.balanceAfter }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <div class="empty-message">
                    <app-empty-state />
                </div>
            </ng-template>
        </p-table>
        <p-paginator
            (onPageChange)="onPageChange($event)"
            [first]="0"
            [rows]="limit"
            [totalRecords]="total"
            [rowsPerPageOptions]="[10, 20, 30]">
        </p-paginator>
    </div>
    <div class="flex justify-content-end">
        <span>الرصيد الحالي: {{ -customer?.dueBalance || 0 }} ر.س</span>
    </div>
</section>
